import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ClientService } from '../services/client.service';
import { AuthService } from '../services/auth.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { APIUrl } from '../constant/api-call';
import { PERMISSION } from '../constant/permission';
import { PrimeNgModule } from '../shared/prime-ng.module';
import { CommonModule } from '@angular/common';
import { ProjectService } from '../services/project.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PrimeNgModule, RouterModule],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent {
  public resetForm: FormGroup;
  public commonDataObject = {
    APIObj: APIUrl,
    permissionObj: PERMISSION,
    projectMaster: [] as any[],
    selectedProject: null,
    isLoad : true,
    issuccessAlert : false,
    iserrorAlert : false,
    apiMeassge : '',
    isMatch : false
  }
  showOldPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;

  constructor(
    private fb: FormBuilder,
    private clientService: ClientService,
    private authService: AuthService,
    private projectService: ProjectService,
    private router: Router) {
    this.resetForm = this.fb.group({
      user_login_name: [''],
      old_password: ['', Validators.required],
      new_password: ['', Validators.required],
      confirm_password: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.commonDataObject.isLoad = false;
      this.projectService.getMasterData();
    }, 1000);
  }

  resetPW() {
    let email = sessionStorage.getItem('email_address');
    let payload = {
      "old_password": this.resetForm.get('old_password')?.value ?? '',
      "new_password": this.resetForm.get('confirm_password')?.value ?? '',
      "email_address": email ?? ''
    }
    this.clientService.postAPI(this.commonDataObject.APIObj.RESET_PASSWORD, payload).subscribe((res: any) => {
      if (res && res.code === "CSR_MS_OK_200") {
        this.commonDataObject.apiMeassge = res.message;
        this.commonDataObject.issuccessAlert = true;
        this.authService.destroyStorage();
        setTimeout(() => {
          this.commonDataObject.isLoad = false;
          this.commonDataObject.issuccessAlert = false;
        }, 1000);
        this.router.navigate(['/login']);
      }
      else {
        this.commonDataObject.apiMeassge = res.message;
        this.commonDataObject.iserrorAlert = true;
      }
      setTimeout(() => {
        this.commonDataObject.isLoad = false;
        this.commonDataObject.iserrorAlert = false;
      }, 1000);
    },
      (error) => {
        this.commonDataObject.iserrorAlert = true;
        this.commonDataObject.apiMeassge = error.error.message;
        setTimeout(() => {
          this.commonDataObject.iserrorAlert = false;
          this.commonDataObject.isLoad = false;
        }, 1000);
      });
  }

  checkPassword() {
    this.commonDataObject.isMatch = this.resetForm.get('confirm_password')?.value === this.resetForm.get('new_password')?.value;
  }

  togglePassword(passwordType: any) {
    if (passwordType === 'oldPassword') {
      this.showOldPassword = !this.showOldPassword;
    } else if (passwordType === 'newPassword') {
      this.showNewPassword = !this.showNewPassword;
    } else if (passwordType === 'confirmPassword') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

}
